import { webClient } from "@shared/apis"
import { Pagination } from "@shared/types"

import { Vod, VodType } from "vod/contexts"

export default {
  get: (
    scheduleId: string | number | undefined,
    vodType: VodType = "NORMAL",
    page = 1,
    size = 1000,
  ) =>
    webClient.get<Pagination<Vod>>(`/vods`, {
      params: { scheduleId, vodType, page, size },
    }),
}
